import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import LoginCard from "./admin/Pages/Login";
import Layout from "./admin/Pages/Layouts";
import VisualizerDetails from "./admin/Pages/VisualizerDetail";
import AddVisualizer from "./admin/Pages/AddVisualizer";
import Collections from "./admin/Pages/Collections";
import DetailsAgain from "./admin/Pages/DetailAgain";
import AngleView from "./admin/Pages/AngleView";
import DragAndDropExample from "./admin/Pages/Demopage";
import AngleLayout from "./admin/Pages/AddLayouts";
import EditVisualizer from "./admin/Pages/EditVisualizer";
import ChildCategory from "./admin/Pages/ChildCategory";
import ProtectedRoute from "./admin/ProtectedRoute";
import ColorSelection from "./admin/Pages/colorSelection";
import HomeBackup from "./pages/homebackup";
import CollectionColors from "./admin/Pages/CollectionColors";
import Groups from "./admin/Pages/Groups";
import Distributor from "./admin/Pages/Distributor";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* <Route path="/visualizer/48h3nena4cl0" element={<Home />} /> */}
        <Route path="/visualizer/:id" element={<Home />} />
        {/* No key in the URL: Home falls back to the default layout and then
            rewrites the address to match, so a bare /visualizer still opens a
            working visualizer instead of a blank page. */}
        <Route path="/visualizer" element={<Home />} />
        {/* A distributor's own visualizer. Same page, but it asks the API what
            this distributor is allowed to see rather than fetching everything. */}
        <Route path="/distributor/:distributorSlug" element={<Home />} />
        
        <Route path="/" element={<LoginCard />} />
        <Route
          path="/admin/layouts"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/collections"
          element={
            <ProtectedRoute>
              <Collections />
            </ProtectedRoute>
          }
          
        />
        <Route
          path="/admin/colors/"
          element={
            <ProtectedRoute>
              <ColorSelection />
            </ProtectedRoute>
          }

        />
        <Route
          path="/admin/groups"
          element={
            <ProtectedRoute>
              <Groups />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/distributor"
          element={
            <ProtectedRoute>
              <Distributor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/collections/:id"
          element={
            <ProtectedRoute>
              <ChildCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/details/:id"
          element={
            <ProtectedRoute>
              <VisualizerDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-visualizer"
          element={
            <ProtectedRoute>
              <AddVisualizer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/colordetail/:id"
          element={
            <ProtectedRoute>
              <DetailsAgain />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/angle/:id"
          element={
            <ProtectedRoute>
              <AngleView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-visualizer/:id"
          element={
            <ProtectedRoute>
              <EditVisualizer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/collections/:collectionId/colors"
          element={
            <ProtectedRoute>
              <CollectionColors />
            </ProtectedRoute>
          }
        />
      
        {/* <Route
          path="/admin/DragAndDropExample"
          element={<DragAndDropExample />}
        /> */}
        <Route path="/admin/layouts/:id" element={<AngleLayout />} />
      </Routes>
    </Router>
  );
};

export default App;
